module.exports = __webpack_public_path__ + "img/home-6-person.cb5e8dda.png";